<template>
    <div>
        <Step1 v-if="chosen_step_no == 1" @onSubmit="onSubmitStep1"></Step1>
        <Step2 v-if="chosen_step_no == 2" @onSubmit="onSubmitStep2"></Step2>
    </div>
</template>

<script>
    import Step1 from '../components/LostPassword/Step1'
    import Step2 from '../components/LostPassword/Step2'
    import { STATUS_CODE } from '@/lib/constants'
  export default {
    name: 'lost-password',
    props: ['step_no'],
    data() {
      return {
        verify_no: '',
        pass: '',
        dr_id: '',
        phone_no: '',
        chosen_step_no: 1
      }
    },
    methods: {
      onSubmitStep1 (verify_no, dr_id, phone_no) {
        // console.log('이벤트 onSubmit 발생!', verify_no, dr_id)
        this.verify_no = verify_no
        this.dr_id = dr_id
        this.phone_no = phone_no
        this.chosen_step_no = 2
      },
      async onSubmitStep2 (pass) {
        // 재입력 패스워드까지 동일 한경우 호출된다.
        this.pass = pass
        let post_data = {dr_id: this.dr_id, phone_no: this.phone_no, verify_no: this.verify_no, pass: this.pass}

        // router.post('/doctor/:dr_id/reset', ctrlDoctor.reset) // User 패스워드 리셋
        let {data} = await this.axios.post(`/auth/dr/reset_pass`, post_data)
        if (data.status !== STATUS_CODE.OK) return alert(data.msg)

        alert('비밀번호가 변경되었습니다')
        this.$router.push('/login')
        // console.log('이벤트 onSubmit step2')
      }
    },
    mounted () {
      this.chosen_step_no = this.step_no
    },
    components: {
      Step1, Step2
    }
  }
</script>

<style scoped>

</style>